import React, { Component } from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import CustomIcon from 'components/common/CustomIcon';
import { openModalPerson, openModalEvent } from 'actions/modalActions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { ContentMessage } from 'components/common/fields/ContentMessage';
import PersonProjects from 'components/cards/person/fields/PersonProjects';
import { intervalTemplate } from 'helpers/fieldsHelpers';

const mapDispatchToProps = { openModalPerson, openModalEvent };

const iconTypes = [
    'case',
    'user-group',
    'calendar-o'
];

@connect(null, mapDispatchToProps)
export default class PersonWorking extends Component {
    static propTypes = {
        person: PropTypes.object.isRequired,
        openModalPerson: PropTypes.func.isRequired,
        openModalEvent: PropTypes.func.isRequired
    }

    openPerson = (item) => {
        this.props.openModalPerson({
            ...item,
            value: item.text.name
        });
    }

    openEvent = (item) => {
        this.props.openModalEvent({
            ...item,
            value: item.text.character
        });
    }

    render() {
        const { person } = this.props;

        return (
            <div>
                { person.workWith.map((workWith, index) => (
                    <div key={index}>
                        <DefinitionHeader translate={workWith.name} iconType={iconTypes[index]} />
                        <div className="panel-view items-list">
                            { workWith.parts.map((item, index) => {
                                const isPerson = item.type === 'People';

                                return (
                                    <Row key={index}>
                                        <Col span={isPerson ? 12 : 16}>
                                            { isPerson ? (
                                                <a className="title" onClick={() => this.openPerson(item)}>
                                                    { item.text.name }
                                                </a>
                                            ) : (
                                                <div>
                                                    <a className="title" onClick={() => this.openEvent(item)}>
                                                        { item.text.character }
                                                    </a>
                                                    <div>
                                                        {item.text.info}
                                                    </div>
                                                </div>
                                            )}
                                        </Col>
                                        <Col span={isPerson ? 12 : 8} className="text-right">
                                            { !isPerson && (
                                                <div><small>{ item.text.name }</small></div>
                                            )}
                                            { item.text.date &&
                                                <span className="date">
                                                    <CustomIcon type="calendar-o" />
                                                    { intervalTemplate(item.text.date, item.text.dateTo, '', '') }
                                                </span>
                                            }
                                        </Col>
                                    </Row>
                                );
                            })}
                            <ContentMessage show={workWith.parts.length === 0} message={<Translate content="common.no_data"/>} />
                        </div>
                    </div>
                ))}
                <PersonProjects partsInProject={person.partsInProject} />
            </div>
        );
    }
}
